/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthCallbackUpdateLineResponse } from "./AuthCallbackUpdateLineResponse";

export type AuthCallbackUpdateLineResponseApiRespoonse = {
  data?: AuthCallbackUpdateLineResponse;
  status?: AuthCallbackUpdateLineResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthCallbackUpdateLineResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
